import React, {useState} from 'react';

import Aside from '../Aside'
import Main from '../Main'

import { FaAngleUp } from 'react-icons/fa';

const Layout = (props) => {
    const[toggled, isCollapsed] = useState(false);
    return ( 
        <>
            <div id="wrapper">
                <Aside toggled={toggled} isCollapsed={isCollapsed} isAdmin={props.isAdmin}/>           
                <Main children={props.children} toggled={toggled} isCollapsed={isCollapsed} />
            </div>

            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"><FaAngleUp className="svg-icon" /></i>
            </a>
        </>
     );
}
 
export default Layout;